import { ImageType } from 'appTypes/items'

export const handleImageError = (
  defaultFallback: string,
  currentImageSrc: string | undefined,
  errorLevel: number,

  setCurrentImgSrc: React.Dispatch<React.SetStateAction<string | undefined>>,
  setErrorLevel: React.Dispatch<React.SetStateAction<number>>,

  fallBack?: string,
) => {
  if (!fallBack) return

  const fallback1 = fallBack || defaultFallback

  if (errorLevel === 0 && currentImageSrc !== fallback1) {
    setCurrentImgSrc(`${fallback1}?fallback=1`)
    setErrorLevel(1)
  } else if (errorLevel === 1 && currentImageSrc !== defaultFallback) {
    setCurrentImgSrc(`${defaultFallback}?fallback=2`)
    setErrorLevel(2)
  }
}

export const handleProductImageFallback = (
  images: ImageType,
  currentImageSrc: string | undefined,
  errorLevel: number,
  setCurrentImgSrc: React.Dispatch<React.SetStateAction<string | undefined>>,
  setErrorLevel: React.Dispatch<React.SetStateAction<number>>,
) => {
  if (!images) return

  const fallbackUrls = [images.miniUrl, images.mediumUrl, images.url]

  if (errorLevel < fallbackUrls.length && currentImageSrc !== fallbackUrls[errorLevel]) {
    setCurrentImgSrc(`${fallbackUrls[errorLevel]}?fallback=${errorLevel + 1}`)
    setErrorLevel(errorLevel + 1)
  }
}
